import { useEffect, useState } from "react";
import { getSharingFeature, SHARING_FEATURE_EVENT } from "../lib/noteEngineState";
import { isDbReady } from "../lib/sqlite";

/** The pull's `collabFeatures.sharing`, kept in `meta` (PLAN.md D8). */
export function useSharingFeature(): boolean {
  const [on, setOn] = useState(() => isDbReady() && getSharingFeature());
  useEffect(() => {
    const update = () => setOn(isDbReady() && getSharingFeature());
    update();
    window.addEventListener(SHARING_FEATURE_EVENT, update);
    return () => window.removeEventListener(SHARING_FEATURE_EVENT, update);
  }, []);
  return on;
}
